'use strict';

module.exports = ['$uibModalInstance', 'tenantId', 'tenantName', 'Tenant', '$scope', '$translate', 'gridConfiguration', 'Member', 'toast', function ($uibModalInstance, tenantId, tenantName, Tenant, $scope, $translate, gridConfiguration, Member, toast) {
    var _this = this;
    _this.tenantId = tenantId;
    _this.tenantName = tenantName;
    this.maxRange = 92;

    // Translate
    // for getActiveUsers
    this.users_active = $translate.instant('DASHBOARD.DASH_USERS.STATISTICS.ACTIVE') ;
    this.users_created = $translate.instant('DASHBOARD.DASH_USERS.STATISTICS.CREATED');
    this.users_deleted = $translate.instant('DASHBOARD.DASH_USERS.STATISTICS.DELETED');
    this.users_inactive = $translate.instant('DASHBOARD.DASH_USERS.STATISTICS.INACTIVE');
    this.dates_error = $translate.instant('DASHBOARD.DASH_USERS.STATISTICS.DATES_ERROR');
    this.user_statistics_error = $translate.instant('DASHBOARD.DASH_USERS.STATISTICS.USER_STATISTICS_ERROR');
    this.users_items = $translate.instant('DASHBOARD.DASH_USERS.STATISTICS.ITEMS');
    // for getAccessLogs
    this.access_users_movements = $translate.instant('DASHBOARD.DASH_USERS.ACCESS_LOG.USERS_WITH_MOVEMENTS');
    this.access_users_validations = $translate.instant('DASHBOARD.DASH_USERS.ACCESS_LOG.USERS_WITH_VALIDATIONS');
    this.access_users_creations = $translate.instant('DASHBOARD.DASH_USERS.ACCESS_LOG.USERS_WITH_CREATIONS');
    this.access_error = $translate.instant('DASHBOARD.DASH_USERS.ACCESS_LOG.ACCESS_ERROR');

    this.close = function () {
        _this.$close(_this.element);
    };

    this.findRecords = function () {
        const fechaDesde = new Date($scope.fechaDesde);
        const fechaHasta = new Date($scope.fechaHasta);
        let today = new Date();
        today.setHours(23, 59, 59, 999);
        const maxFechaHasta = new Date(fechaDesde);
        maxFechaHasta.setDate(maxFechaHasta.getDate() + this.maxRange);

        if (fechaDesde > today || fechaHasta > today || fechaDesde > fechaHasta || fechaHasta > maxFechaHasta) {
            // toast.error($translate.instant('Error en fechas ingresadas. No pueden superar la fecha actual, y deben tener un intervalo máximo de 3 meses.'));
            toast.error($translate.instant(_this.dates_error));

            $scope.fechaHasta = new Date();
            $scope.fechaDesde = new Date();
            // Set the start date to the first day of the current month
            $scope.fechaDesde.setDate(1);
            return
        }
        function formatYYYYMMDD(d) {
            return d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate();
        }
        let fDesde = formatYYYYMMDD($scope.fechaDesde);
        let fHasta = formatYYYYMMDD($scope.fechaHasta);
        Tenant.statistic2({ //query
            tenantId: _this.tenantId,
            avgMensual: true,
            fechaDesde: (fDesde),
            fechaHasta: (fHasta)
        }).$promise.then(function (data) {
            //_this.Tenant = data.response;            
            _this.gridOptions.api.setRowData(data.response);
            _this.loadChart(data.response);
            // _this.getNewUsers();
            _this.getActiveUsers();
            _this.getAccessLogs();
        }).catch(function (err) { });
    }

    this.getActiveUsers = function() {
        // Table Active Users
        $scope.labelsActiveUsers = [];
        $scope.dataActiveUsers = [[]];
        // $scope.seriesActiveUsers = ["Usuarios Activos"];
        $scope.seriesActiveUsers = [_this.users_active];
        
        // Table Created/Deleted/Inactive Users
        $scope.labelsCreateDeleteInactiveUsers = [];
        $scope.dataCreateDeleteInactiveUsers = [[], [], []];
        // $scope.seriesActiveUsers = [_this.users_created, _this.users_deleted, _this.users_inactive];
        $scope.seriesCreateDeleteInactiveUsers = [_this.users_created, _this.users_deleted, _this.users_inactive];

        Member.getActiveDeletedCreatedStats({
            startDate: $scope.fechaDesde,
            endDate: $scope.fechaHasta,
            tenantId: _this.tenantId,
        }).$promise.then(function(data) {
            // console.log('getActiveUsers', data);
            let labelsActiveUsers = Object.keys(data.items)
                .filter(key => !key.startsWith('$'))
                .sort((a, b) => new Date(a) - new Date(b));
            
            // Table Active Users
            let dataActiveUsers = labelsActiveUsers.map(label => data.items[label].active || 0);
            let dataCreatedUsers = labelsActiveUsers.map(label => data.items[label].created || 0);
            let dataDeletedUsers = labelsActiveUsers.map(label => data.items[label].deleted || 0);
            let dataInactiveUsers = labelsActiveUsers.map(label => data.items[label].inactive || 0);
            // Table Created/Deleted/Inactive Users
            if (dataActiveUsers.length === 0) dataActiveUsers = [0];
            if (dataCreatedUsers.length === 0) dataCreatedUsers = [0];
            if (dataDeletedUsers.length === 0) dataDeletedUsers = [0];
            if (dataInactiveUsers.length === 0) dataInactiveUsers = [0];

            $scope.labelsActiveUsers = labelsActiveUsers;
            $scope.dataActiveUsers = [dataActiveUsers];
            // $scope.seriesActiveUsers = ["Usuarios Activos"];
            $scope.seriesActiveUsers = [_this.users_active];

            $scope.labelsCreateDeleteInactiveUsers = labelsActiveUsers;
            $scope.dataCreateDeleteInactiveUsers = [dataCreatedUsers, dataDeletedUsers, dataInactiveUsers];
            // $scope.seriesActiveUsers = ["Usuarios Creados", "Usuarios Eliminados", "Usuarios Inactivos"];
            $scope.seriesCreateDeleteInactiveUsers = [_this.users_created, _this.users_deleted, _this.users_inactive];

        }).catch(function(err) {
            // reset values
            $scope.labelsActiveUsers = [];
            $scope.dataActiveUsers = [[]];
            // $scope.seriesActiveUsers = ["Usuarios Activos"];
            $scope.seriesActiveUsers = [_this.users_active];

            $scope.labelsCreateDeleteInactiveUsers = [];
            $scope.dataCreateDeleteInactiveUsers = [[], []];
            // $scope.seriesCreateDeleteInactiveUsers = ["Usuarios Creados", "Usuarios Eliminados", "Usuarios Inactivos"];
            $scope.seriesCreateDeleteInactiveUsers = [_this.users_created, _this.users_deleted, _this.users_inactive];
            
            // console.error('Error al obtener información de estadísticas de usuarios:', err);
            console.error(_this.user_statistics_error, err);
        });
    }

    this.getAccessLogs = function () {    
        // Inicialización de variables
        $scope.labelsAccessLog = [];
        $scope.dataAccessLog = [[], [], []];
        // 'Cantidad de Usuarios con Movimientos', 'Cantidad de Usuarios con Validaciones', 'Cantidad de Usuarios con Items Creados'
        $scope.seriesAccessLog = [ _this.access_users_movements, _this.access_users_validations, _this.access_users_creations];
        $scope.monthsInRange = []
    
        Tenant.accessLogs({ id: _this.tenantId })
            .$promise.then(function (data) {
                // console.log('Access Logs', data);
    
                // Paso 1: Extraer año y mes de las fechas desde y hasta
                const startYearMonth = new Date($scope.fechaDesde.getFullYear(), $scope.fechaDesde.getMonth(), 1);
                const endYearMonth = new Date($scope.fechaHasta.getFullYear(), $scope.fechaHasta.getMonth(), 1);
                
                let currentMonth = new Date(startYearMonth);
                while (currentMonth <= endYearMonth) {
                    const yearMonth = currentMonth.toISOString().slice(0, 7); // Formato 'YYYY-MM'
                    $scope.monthsInRange.push(yearMonth);
                    currentMonth.setMonth(currentMonth.getMonth() + 1);
                }

                // Paso 2: Crear un mapa de datos de acceso para cada mes con valores iniciales en 0
                const monthDataMap = {};
                $scope.monthsInRange.forEach(month => {
                    monthDataMap[month] = {
                        usersWithMovements: 0,
                        usersWithValidations: 0,
                        usersWithCreations: 0
                    };
                });

                // Paso 3: Rellenar el mapa con los datos existentes
                data.forEach(item => {
                    if (monthDataMap[item.month]) {
                        monthDataMap[item.month].usersWithMovements += item.counter > 0 ? 1 : 0;
                        monthDataMap[item.month].usersWithValidations += item.counterItemValidation > 0 ? 1 : 0;
                        monthDataMap[item.month].usersWithCreations += item.counterItemCreation > 0 ? 1 : 0;
                    }
                });

                // Paso 4: Preparar los datos para el gráfico
                $scope.labelsAccessLog = $scope.monthsInRange; // Ejemplo: ["2024-08", "2024-09", "2024-10"]
                $scope.dataAccessLog = [
                    $scope.monthsInRange.map(month => monthDataMap[month].usersWithMovements),
                    $scope.monthsInRange.map(month => monthDataMap[month].usersWithValidations),
                    $scope.monthsInRange.map(month => monthDataMap[month].usersWithCreations)
                ];

                // console.log('Processed Chart Data:', $scope.labelsAccessLog, $scope.dataAccessLog);
            })
            .catch(function (err) {
                // Reinicialización de valores en caso de error
                $scope.labelsAccessLog = [];
                $scope.dataAccessLog = [[], [], []];
                // 'Cantidad de Usuarios con Movimientos', 'Cantidad de Usuarios con Validaciones', 'Cantidad de Usuarios con Items Creados'
                $scope.seriesAccessLog = [ _this.access_users_movements, _this.access_users_validations, _this.access_users_creations];
    
                $scope.monthsInRange = [];
                // 'Error al obtener información de logs de acceso:'
                console.error(_this.access_error, err);
            });
    };
    
    this.loadChart = function (resp) {
        // Usuario
        let labels = {};
        let series = {};
        let dataTmp = {};
        $scope.labels = [];
        $scope.data = [];
        $scope.series = [];

        // Totales
        let labelsTot = {};
        let seriesTot = {};
        let dataTmpTot = {};
        $scope.dataTot = [];
        $scope.seriesTot = [];

        // Form        
        let seriesF = {};
        let dataTmpF = {};        
        $scope.dataF = [];
        $scope.seriesF = [];

        resp.forEach((x) => {
            x = x.data || x;
            let usuario = x.firstName + " " + x.lastName;
            let form = x.formName;
            seriesF[form] = [];
            series[usuario] = [];
            seriesTot["Total"] = [];
            labels[x.fechaCarga] = null;
            dataTmp[usuario + "." + x.fechaCarga] = parseFloat(dataTmp[usuario + "." + x.fechaCarga] || 0) + parseFloat(x.cantidad);
            dataTmpF[form + "." + x.fechaCarga] = parseFloat(dataTmpF[form + "." + x.fechaCarga] || 0) + parseFloat(x.cantidad);
            dataTmpTot[x.fechaCarga] = parseFloat(dataTmpTot[x.fechaCarga] || 0) + parseFloat(x.cantidad);

        });
        Object.keys(labels).sort().reverse().forEach(l => {
            $scope.labels.push(l);
            Object.keys(series).forEach(s => {
                if (dataTmp[s + "." + l] != undefined) {
                    series[s].push(dataTmp[s + "." + l]);
                }
                else
                    series[s].push(0);
            });
            Object.keys(seriesF).forEach(s => {
                if (dataTmpF[s + "." + l] != undefined) {
                    seriesF[s].push(dataTmpF[s + "." + l]);
                }
                else
                    seriesF[s].push(0);
            });
            if (dataTmpTot[l] != undefined) {
                seriesTot["Total"].push(dataTmpTot[l]);
            }
            else
                seriesTot["Total"].push(0);

        });
        let limite = 0;
        
        Object.keys(series).forEach(s => {
            if (limite < 10) {
                $scope.series.push(s);
                $scope.data.push(series[s]);
            }
            limite += 1;
        });
        limite = 0;
        Object.keys(seriesF).forEach(s => {
            if (limite < 10) {
                $scope.seriesF.push(s);
                $scope.dataF.push(seriesF[s]);
            }
            limite += 1;
        });

        // $scope.seriesTot.push("Items");
        $scope.seriesTot.push(_this.users_items);
        
        $scope.dataTot.push(seriesTot["Total"]);

        $scope.chartOptions = {
            maintainAspectRatio: false,
            legend: {
                display: true, position: 'right', labels: { boxWidth: 2 }
            }
        };
    }

    $scope.fechaHasta = new Date();
    $scope.fechaDesde = new Date();
    $scope.fechaDesde.setDate(1);

    $scope.dateOptions = {
        formatYear: 'yyyy',
        startingDay: 1
    };
    $scope.status = {
        openedHasta: false, openedDesde: false
    };
    $scope.openCalendario = function ($event, obj) {
        $scope.status[obj] = true;
    };

    function getUser(params) {
        if (params.data) {
            return params.data.firstName + ' ' + params.data.lastName;
        }
        return '';
    }

    _this.columnDefs = [
        {
            headerName: $translate.instant('DASHBOARD.STATS.COLS.MEMBER'),
            field: "member", valueGetter: getUser,
            colId: 'memberName'
        },
        {
            headerName: $translate.instant('DASHBOARD.STATS.COLS.FORM'),
            field: 'formName',
            colId: 'formName'
        },
        {
            headerName: $translate.instant('DASHBOARD.STATS.COLS.PERIOD'),
            field: 'fechaCarga',
            colId: 'member-roles',
            width: 150,
        },
        {
            headerName: $translate.instant('DASHBOARD.STATS.COLS.ITEMS'),
            field: 'cantidad', filter: 'number',
            colId: 'member-items',
            width: 110,
        },
        {
            headerName: $translate.instant('DASHBOARD.STATS.COLS.DEPARTMENT'),
            field: 'deptName',
            colId: 'deptName'
        }
    ];

    _this.gridOptions = {
        debug: false,
        rowBuffer: 0,
        columnDefs: _this.columnDefs,
        enableFilter: true,
        enableColResize: true,
        enableSorting: true,
        forPrint: true,
        rowData: _this.items,
        rowHeight: 40,
        headerHeight: 40,
        angularCompileRows: true,
        angularCompileFilters: true,
        angularCompileHeaders: true,
        localeText: gridConfiguration.localeText,
        onAfterFilterChanged: function () {
            _this.loadChart(_this.gridOptions.api.inMemoryRowController.rowsToDisplay);
        }
    };

    _this.findRecords();
    // _this.getActiveUsers();
}]